import { useGQL } from '@sbvr/lbe-compositions';
import User from '@/core/store/types/User';
import UserInput from '@/core/store/types/UserInput';
const gql = useGQL();

const userFragment = `
  id
  email
  name
  agreedAt
  upcomingAgreedAt
  upcomingAgreedAtRequiredBy
  reservationEmails
  systemEmails
  accessLevel
  validated
  pusherConfiguration {
    authEndpoint
    host
    key
    broadcaster
  }
`;

export async function lookupUserSetup (validationKey: string): Promise<User> {
  const query = `
    query lookupUserSetup ($validationKey: String) {
      user: lookupUserSetup(validationKey: $validationKey) {
        id
        name
        email
      }
    }
  `;
  const data = await gql.request(query, { validationKey });
  return data?.user as User;
}

export async function storeUserSetup (user: UserInput, validationKey: string): Promise<any> {
  const mutation = `mutation storeUserSetup (
    $user: UserInput
    $validationKey: String
  ) {
    storedUser: storeUserSetup (
      user: $user
      validationKey: $validationKey
    ) {
      ${userFragment}
      token
    }
  }`;

  const { storedUser } = await gql.request(mutation, { user, validationKey }) as { storedUser: any }; ;
  return storedUser;
}
